/**
 * Detects image URLs that have already been optimized by Cloudflare Image
 * Resizing at the Magento origin, i.e. the output of `getResizedImageUrl` and
 * `getOptimizedMagentoImageUrl` (path rewritten under `/images/` on an `m24-`
 * Magento host).
 *
 * Such assets must skip `next/image` (`/_next/image`) to avoid a redundant
 * second optimization pass on the OpenNext Cloudflare Images binding.
 */
export const isOptimizedMagentoImageUrl = (src: string | undefined): boolean => {
  if (!src?.startsWith("http")) {
    return false;
  }

  try {
    const { pathname, hostname } = new URL(src);
    return pathname.startsWith("/images/") && hostname.startsWith("m24-");
  } catch {
    return false;
  }
};
